import { render, staticRenderFns } from "./goods_detail.vue?vue&type=template&id=45a08edf&scoped=true&"
import script from "./goods_detail.vue?vue&type=script&lang=js&"
export * from "./goods_detail.vue?vue&type=script&lang=js&"
import style0 from "./goods_detail.vue?vue&type=style&index=0&id=45a08edf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a08edf",
  null
  
)

export default component.exports